module.exports = __webpack_public_path__ + "img/interactive-hero-slider-toyota-23.b4382019.jpg";